import { useEffect, useRef, useState } from "react";
import CopyableText from "src/components/CopyableText";
import { Tooltip } from "src/components/MuiGenerals";

function OverflowTooltipText({
  text,
  copyable,
}: {
  text: string | number;
  copyable?: boolean;
}) {
  const divRef = useRef<HTMLDivElement>(null);
  const [isTooltipHidden, setIsTooltipHidden] = useState(true);

  useEffect(() => {
    if (!divRef.current) return;

    setIsTooltipHidden(
      divRef.current.scrollWidth <= divRef.current.offsetWidth,
    );
  }, [text, setIsTooltipHidden]);

  return (
    <Tooltip disableHoverListener={isTooltipHidden} title={text}>
      {copyable ? (
        <CopyableText ref={divRef} text={String(text)} handleOverflow />
      ) : (
        <div
          ref={divRef}
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {text}
        </div>
      )}
    </Tooltip>
  );
}

export default OverflowTooltipText;
